// custom typefaces
import "./static/font/inter.css"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// Authentication
import "firebase/auth"

import React from "react"
import AuthProvider from "./src/context/auth"

const GOOGLE_ANALYTICS_ID =
  process.env.GATSBY_GOOGLE_ANALYTICS_ID || "G-RR8NENFRC1"

let lastTrackedPath

const sendPageView = location => {
  if (
    process.env.NODE_ENV !== "production" ||
    !GOOGLE_ANALYTICS_ID ||
    typeof window.gtag !== "function"
  ) {
    return
  }

  const pagePath = location
    ? `${location.pathname}${location.search}${location.hash}`
    : window.location.pathname + window.location.search + window.location.hash

  if (pagePath === lastTrackedPath) {
    return
  }

  lastTrackedPath = pagePath

  window.gtag("event", "page_view", {
    page_title: document.title,
    page_location: window.location.href,
    page_path: pagePath,
    send_to: GOOGLE_ANALYTICS_ID,
  })
}

export const wrapRootElement = ({ element }) => (
  <AuthProvider>{element}</AuthProvider>
)

export const onInitialClientRender = () => {
  window.setTimeout(() => sendPageView(window.location), 32)
}

export const onRouteUpdate = ({ location }) => {
  window.setTimeout(() => sendPageView(location), 32)
}
